var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpecialService = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "#3DD598",
  r: 12.5,
  cy: 12.5,
  cx: 12.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.25 18.917v-5.472l2.922-1.292v-2.32l3.63-1.86V6.522h-1.417V5.46h1.417V4.042h1.063V5.46h1.416v1.062h-1.416v1.453l3.63 1.859v2.32l2.922 1.292v5.472h-6.198v-2.833a.858.858 0 0 0-.254-.63.852.852 0 0 0-.628-.255c-.25 0-.461.084-.632.254a.853.853 0 0 0-.257.631v2.833H5.25zm1.063-1.062h4.072v-1.806c0-.543.19-1.01.57-1.4.378-.389.839-.584 1.38-.584.542 0 1.002.195 1.38.585.377.39.566.856.566 1.399v1.806h4.073v-3.79l-2.922-1.292v-2.356l-3.099-1.611-3.099 1.611v2.356l-2.921 1.292v3.79zm6.021-5.047c.271 0 .501-.095.69-.284a.942.942 0 0 0 .283-.691c0-.27-.094-.5-.284-.69a.942.942 0 0 0-.69-.283c-.271 0-.501.095-.69.284a.942.942 0 0 0-.284.691c0 .27.095.5.285.69.19.188.42.283.69.283z"
})));
export { SvgSpecialService as ReactComponent };
export default __webpack_public_path__ + "images/special-service.svg";